import { Category, QueryCategoryPageOutput } from 'types/types';
import { CategoryPage } from './types';
import {
  GALLERY_SIZE,
  MAX_GALLERIES_PER_SHOP,
  LAYOUT_COLLECTION,
} from './constants';
import { prepProductListing } from 'components/_shared/widgets/product-listing/utils';

/**
 * Data/props preparation.
 */
export const categoryPageProps: (
  data: QueryCategoryPageOutput,
  categoryId: string,
  category?: Category
) => CategoryPage = ({ products }, categoryId, category) => ({
  category: category || null,
  categoryId,
  items: prepProductListing({
    products,
    withShops: true,
    minItemsPerShop: 3,
    gallerySize: GALLERY_SIZE,
    maxGalleriesPerShop: MAX_GALLERIES_PER_SHOP,
    galleryLayouts: LAYOUT_COLLECTION,
  }),
  banner: category?.bannerImage || null,
});
